import React from "react"
import Layout from "../components/layout"
export default () => (
  <Layout>
    <div>
      <h1>I'd love to talk! Email me at the address below</h1>
      <p>
        <a href="mailto:me@example.com">ghezala.anssam@gmail.com</a>
      </p>
    </div>
  </Layout>
)
